// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Xo1ME","noInteraction":"EventWrapper_noInteraction__1nWWE","pointerPassthrough":"EventWrapper_pointerPassthrough__39GXc"};